import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function DiscordCallback() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const [msg, setMsg] = useState("Linking your Discord account…");

    useEffect(() => {
        const code = params.get("code");
        const state = params.get("state");
        (async () => {
            try {
                await api.post("/discord/link", { code, state });
                await refresh();
                setMsg("Discord linked! Redirecting…");
            } catch {
                setMsg("Could not link Discord. Redirecting…");
            }
            setTimeout(() => navigate("/player/connections"), 1200);
        })();
    }, []); // eslint-disable-line

    return (
        <div className="min-h-screen hud-grid flex items-center justify-center text-foreground">
            <div className="text-center">
                <Loader2 className="animate-spin mx-auto text-discord mb-3" size={28} />
                <p className="font-heading text-xl uppercase">{msg}</p>
            </div>
        </div>
    );
}
